import React from 'react';

export const Økonomi = () => {
  return (
    <>
      Økonomi page
    </>
  )
}